import React, { useState, useEffect } from "react";
import {
  Typography,
  Grid,
  Container,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
} from "@mui/material";

import api from "../../globals/axios";
import CustomAppBar from "../../components/AppBar";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { CustomTitle } from "../../components/Custom/CustomTypography";
import CustomButton from "../../components/Custom/CustomButton";
import { useAlert } from "../../components/Alert";

export default function CreateHarvestNew() {
  const navigate = useNavigate();
  const [crops, setCrops] = useState([]);
  const [formData, setFormData] = useState({});
  const { t } = useTranslation();
  const { showAlert } = useAlert();
  const [searchParams] = useSearchParams();
  const cropId = searchParams.get("cropId");

  useEffect(() => {
    api.get("/farmer/crops/").then((res) => {
      const _crops = res.data.map((f) => {
        const name = `${f.farmland?.farm_name} ${f.seed_type} [${f.sowing_date}]`;
        return { id: f.id, crop_name: name };
      });
      setCrops(_crops);
      if (cropId) {
        const selectedCrop = _crops.find(
          (crop) => crop.id === parseInt(cropId, 10)
        );
        if (selectedCrop) {
          setFormData((prevData) => ({
            ...prevData,
            crop_id: selectedCrop.id,
          }));
        }
      }
    });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const onFileChange = (event, fileType) => {
    setFormData({ ...formData, [fileType]: event.target.files[0] });
  };
  const fileUploadSections = [
    {
      label: t("Harvest Picture Upload"),
      name: "picture",
      accept: "image/*",
      optionalText: t("(optional)"),
    },
    {
      label: t("Weigh Bridge Receipt"),
      name: "weigh_bridge_receipt",
      accept: ".pdf",
      optionalText: t("PDF file Only *"),
    },
  ];

  const createLabTest = () => {
    const fileFields = ["picture", "weigh_bridge_receipt"];

    const _formData = new FormData();
    for (const key in formData) {
      if (formData[key] instanceof FileList) {
        _formData.append(key, formData[key][0]);
      } else {
        if (fileFields.includes(key) && typeof formData[key] === "string")
          continue;
        _formData.append(key, formData[key]);
      }
    }

    api
      .post("/farmer/harvests/", _formData)
      .then((response) => {
        console.log(response.data);
        showAlert("success", "Harvest added successfully");
        const redirectUrl = cropId ? `/farmer/crop/${cropId}` : "/";
        navigate(redirectUrl);
      })
      .catch((error) => {
        console.log(error);
        showAlert("success", "Error adding harvest" + error);
      });
  };
  return (
    <>
      <CustomAppBar />
      <Container maxWidth="xs">
        <div>
          <Grid
            container
            // spacing={1}
            justify="center"
            direction="column"
            style={{ marginTop: "10px" }}
          >
            <CustomTitle>{t("Add Harvest")}</CustomTitle>

            <FormControl fullWidth sx={{ marginTop: 2 }}>
              <InputLabel id="token-select-label">{t("Crop")}</InputLabel>
              <Select
                label={t("Crop")}
                name="crop_id"
                value={formData.crop_id || ""}
                onChange={handleChange}
                disabled={!!cropId} // Disable if cropId is provided in URL
              >
                {crops.map((b) => (
                  <MenuItem key={b.id} value={b.id}>
                    {b.crop_name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField
              margin="normal"
              required
              fullWidth
              type="date"
              label={t("Harvest Date")}
              InputLabelProps={{ shrink: true }}
              name="harvest_date"
              value={formData.harvest_date || ""}
              onChange={handleChange}
            />

            <TextField
              margin="normal"
              required
              fullWidth
              label={t("Quantity(kg)")}
              type="number"
              name="quantity"
              value={formData.quantity || ""}
              onChange={handleChange}
            />
            <Grid container sx={{ marginTop: "20px" }}>
              {fileUploadSections.map((section, index) => (
                <React.Fragment key={index}>
                  <Grid item xs={8} sx={{ marginTop: "20px" }}>
                    <Typography style={{ fontSize: "12px", fontWeight: 600 }}>
                      {section.label}
                    </Typography>
                    <span
                      style={{
                        fontSize: "10px",
                        fontWeight: 400,
                      }}
                    >
                      {section.optionalText}
                    </span>
                  </Grid>
                  <Grid item xs={4} sx={{ marginTop: "20px" }}>
                    <Button
                      variant="contained"
                      component="label"
                      style={{
                        marginLeft: "auto",
                        color: "white",
                        width: "100%",
                        height: "33px",
                      }}
                    >
                      {t("Upload")}
                      <input
                        type="file"
                        name={section.name}
                        accept={section.accept}
                        onChange={(e) => onFileChange(e, section.name)}
                        style={{ display: "none" }}
                      />
                    </Button>
                  </Grid>
                </React.Fragment>
              ))}
            </Grid>
            <CustomButton onClick={createLabTest}>
              {t("Add Harvest")}
            </CustomButton>
          </Grid>
        </div>
      </Container>
    </>
  );
}
